import { AttachmentApiService } from "./AttachmentApiService";
import { ChatApiService } from "./ChatApiService";
import { RoomApiService } from "./RoomApiService";

class RequestsRepository {
    ChatApiService = new ChatApiService();
    RoomApiService = new RoomApiService();
    AttachmentApiService = new AttachmentApiService();
}
export const requestsRepository = new RequestsRepository();